"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attrCreatApi = attrCreatApi;
exports.attrDeleteApi = attrDeleteApi;
exports.attrEditApi = attrEditApi;
exports.attrInfoApi = attrInfoApi;
exports.auditEditApi = auditEditApi;
exports.batchFileName = batchFileName;
exports.batchImage = batchImage;
exports.batchList = batchList;
exports.batchLogs = batchLogs;
exports.batchOffShellt = batchOffShellt;
exports.batchPutOnShell = batchPutOnShell;
exports.batchSpuImage = batchSpuImage;
exports.batchTask = batchTask;
exports.batchTemplate = batchTemplate;
exports.batchTurnTask = batchTurnTask;
exports.batchTurnTaskList = batchTurnTaskList;
exports.batchUpdateCpStatus = batchUpdateCpStatus;
exports.batchUpdateStatus = batchUpdateStatus;
exports.cardBatchGenerate = cardBatchGenerate;
exports.cardBatchLogExport = cardBatchLogExport;
exports.cardBatchLogPage = cardBatchLogPage;
exports.cardBatchSkuOptions = cardBatchSkuOptions;
exports.cardCustomerAppOptions = cardCustomerAppOptions;
exports.cardInstanceCardExport = cardInstanceCardExport;
exports.cardInstanceCardPage = cardInstanceCardPage;
exports.cardInstanceUseDetail = cardInstanceUseDetail;
exports.cardRightUseRecord = cardRightUseRecord;
exports.cardSkuAdd = cardSkuAdd;
exports.cardSkuDelete = cardSkuDelete;
exports.cardSkuLists = cardSkuLists;
exports.cardSkuPlatformOptions = cardSkuPlatformOptions;
exports.cardSkuProductOptions = cardSkuProductOptions;
exports.categoryApi = categoryApi;
exports.changeJdPrice = changeJdPrice;
exports.changeJdSort = changeJdSort;
exports.changeThirdPrice = changeThirdPrice;
exports.changeThirdState = changeThirdState;
exports.copyConfigApi = copyConfigApi;
exports.copyProductApi = copyProductApi;
exports.deleteAndSyncProduct = deleteAndSyncProduct;
exports.downloadMeijingOneCardImportTemplate = downloadMeijingOneCardImportTemplate;
exports.exportJdGoods = exportJdGoods;
exports.exportThird = exportThird;
exports.getBrandrApi = getBrandrApi;
exports.getCityApi = getCityApi;
exports.getCompanyLists = getCompanyLists;
exports.getLabelApi = getLabelApi;
exports.getProductRemoveByProduct = getProductRemoveByProduct;
exports.getProductSave = getProductSave;
exports.getProductSaveDetail = getProductSaveDetail;
exports.getProductSaveHasDraft = getProductSaveHasDraft;
exports.getSupplierApi = getSupplierApi;
exports.getThirdSkuList = getThirdSkuList;
exports.importProductApi = importProductApi;
exports.importThirdGoods = importThirdGoods;
exports.offShellApi = offShellApi;
exports.offShellApi2 = offShellApi2;
exports.oneCardMeijingImport = oneCardMeijingImport;
exports.oneCardRightConfigDetail = oneCardRightConfigDetail;
exports.oneCardRightConfigPage = oneCardRightConfigPage;
exports.oneCardRightConfigSave = oneCardRightConfigSave;
exports.oneCardRightProductOptions = oneCardRightProductOptions;
exports.oneCardTypeOptions = oneCardTypeOptions;
exports.orderExcelApi = orderExcelApi;
exports.priceAdjustmentLogApi = priceAdjustmentLogApi;
exports.priceAdjustmentLogApi2 = priceAdjustmentLogApi2;
exports.productCreateApi = productCreateApi;
exports.productCreateSupplierApi = productCreateSupplierApi;
exports.productDeleteApi = productDeleteApi;
exports.productDetailApi = productDetailApi;
exports.productDetailApi2 = productDetailApi2;
exports.productExcelApi = productExcelApi;
exports.productExportApi = productExportApi;
exports.productHeadersApi = productHeadersApi;
exports.productLstApi = productLstApi;
exports.productLstApiSupplier = productLstApiSupplier;
exports.productUpdateApi = productUpdateApi;
exports.productUpdateSupplierApi = productUpdateSupplierApi;
exports.putOnShellApi = putOnShellApi;
exports.putOnShellApi2 = putOnShellApi2;
exports.replyCommentApi = replyCommentApi;
exports.replyCreatApi = replyCreatApi;
exports.replyDeleteApi = replyDeleteApi;
exports.replyEditApi = replyEditApi;
exports.replyInfoApi = replyInfoApi;
exports.replyListApi = replyListApi;
exports.restoreApi = restoreApi;
exports.syncProduct = syncProduct;
exports.syncThirdSku = syncThirdSku;
exports.templateListApi = templateListApi;
exports.thirdSkuLists = thirdSkuLists;
var _elementUi = require("element-ui");
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
/**
 * 商品标签 keyword
 */
function getLabelApi(params) {
  return (0, _request.default)({
    url: "/admin/merchant/label/autoList",
    method: 'GET',
    params: params
  });
}

/**
 * 品牌 keyword
 */
function getBrandrApi(params) {
  return (0, _request.default)({
    url: "/admin/store/brand/autoList",
    method: 'GET',
    params: params
  });
}

/**
 * 供应商
 */
function getSupplierApi(params) {
  return (0, _request.default)({
    url: "/admin/business/supplier/autoList",
    method: 'GET',
    params: params
  });
}

/**
 * 产地
 */
function getCityApi() {
  return (0, _request.default)({
    url: "/admin/system/city/list/treeLevel3",
    method: 'GET'
  });
}

/**
 * 新增商品
 * @param pram
 */
function productCreateApi(data) {
  return (0, _request.default)({
    url: '/admin/store/product/save',
    method: 'POST',
    data: data
  });
}

/**
 * 新增商品 - 供应商
 * @param pram
 */
function productCreateSupplierApi(data) {
  return (0, _request.default)({
    url: '/admin/supplier/product/save',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑商品
 * @param pram
 */
function productUpdateApi(data) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _request.default)({
    url: '/admin/store/product/update',
    method: 'POST',
    data: data,
    params: params
  });
}

/**
 * 编辑商品 - 供应商
 * @param pram
 */
function productUpdateSupplierApi(data) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _request.default)({
    url: '/admin/supplier/product/update',
    method: 'POST',
    data: data,
    params: params
  });
}

/**
 * 商品详情
 * @param pram
 */
function productDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/store/product/info/".concat(id),
    method: 'GET'
  });
}

/**
 * 商品详情-供应商
 * @param pram
 */
function productDetailApi2(id) {
  return (0, _request.default)({
    url: "/admin/supplier/product/info/".concat(id),
    method: 'GET'
  });
}

/**
 * 删除商品
 * @param pram
 */
function productDeleteApi(id, type) {
  return (0, _request.default)({
    url: "/admin/store/product/delete/".concat(id),
    method: 'get',
    params: {
      type: type
    }
  });
}

/**
 * 商品列表 表头数量
 */
function productHeadersApi() {
  return (0, _request.default)({
    url: '/admin/store/product/tabs/headers',
    method: 'GET'
  });
}

/**
 * 商品列表
 * @param pram
 */
function productLstApi() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = _objectSpread({}, data);
  if (params.showCateId) {
    params.showCateId = params.showCateId.join(',');
  }
  var _ref = data.dateRange || [],
    _ref2 = _slicedToArray(_ref, 2),
    startTime = _ref2[0],
    endTime = _ref2[1];
  if (startTime && endTime) {
    params['startTime'] = startTime;
    params['endTime'] = endTime;
  }
  ;
  delete params.dateRange;
  return (0, _request.default)({
    url: '/admin/store/product/list',
    method: 'GET',
    params: params
  });
}

/**
 * 商品列表-供应商
 * @param pram
 */
function productLstApiSupplier() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = _objectSpread({}, data);
  if (params.showCateId) {
    params.showCateId = params.showCateId.join(',');
  }
  var _ref3 = data.dateRange || [],
    _ref4 = _slicedToArray(_ref3, 2),
    startTime = _ref4[0],
    endTime = _ref4[1];
  if (startTime && endTime) {
    params['startTime'] = startTime;
    params['endTime'] = endTime;
  }
  ;
  delete params.dateRange;
  return (0, _request.default)({
    // url: '/admin/store/product/list',
    url: '/admin/supplier/product/list',
    method: 'GET',
    params: params
  });
}

/**
 * 商品分类
 * @param pram
 */
function categoryApi(params) {
  return (0, _request.default)({
    url: '/admin/category/list/tree',
    method: 'GET',
    params: params
  });
}
/**
 * 商品上架
 * @param pram
 */
function putOnShellApi(id) {
  return (0, _request.default)({
    url: "/admin/store/product/putOnShell/".concat(id),
    method: 'GET'
  });
}

/**
 * 商品上架 - 供应商
 * @param pram
 */
function putOnShellApi2(id) {
  return (0, _request.default)({
    url: "/admin/supplier/product/putOnShell/".concat(id),
    method: 'GET'
  });
}
/**
 * 商品下架
 * @param pram
 */
function offShellApi(id) {
  return (0, _request.default)({
    url: "/admin/store/product/offShell/".concat(id),
    method: 'GET'
  });
}

/**
 * 商品下架 - 供应商
 * @param pram
 */
function offShellApi2(id) {
  return (0, _request.default)({
    url: "/admin/supplier/product/offShell/".concat(id),
    method: 'GET'
  });
}
/**
 * 商品规格 列表
 * @param pram
 */
function templateListApi(params) {
  return (0, _request.default)({
    url: '/admin/store/product/rule/list',
    method: 'GET',
    params: params
  });
}
/**
 * 商品规格 删除
 * @param pram
 */
function attrDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/store/product/rule/delete/".concat(id),
    method: 'get'
  });
}
/**
 * 商品规格 新增
 * @param pram
 */
function attrCreatApi(data) {
  return (0, _request.default)({
    url: '/admin/store/product/rule/save',
    method: 'POST',
    data: data
  });
}
/**
 * 商品规格 编辑
 * @param pram
 */
function attrEditApi(data) {
  return (0, _request.default)({
    url: '/admin/store/product/rule/update',
    method: 'POST',
    data: data
  });
}
/**
 * 商品规格 详情
 * @param pram
 */
function attrInfoApi(id) {
  return (0, _request.default)({
    url: "admin/store/product/rule/info/".concat(id),
    method: 'GET'
  });
}
/**
 * 商品评论 列表
 * @param pram
 */
function replyListApi(params) {
  return (0, _request.default)({
    url: '/admin/store/product/reply/list',
    method: 'GET',
    params: params
  });
}
/**
 * 商品评论 新增
 * @param pram
 */
function replyCreatApi(data) {
  return (0, _request.default)({
    url: '/admin/store/product/reply/save',
    method: 'POST',
    data: data
  });
}
/**
 * 商品评论 编辑
 * @param pram
 */
function replyEditApi(data) {
  return (0, _request.default)({
    url: '/admin/store/product/reply/update',
    method: 'POST',
    data: data
  });
}
/**
 * 商品评论 详情
 * @param pram
 */
function replyInfoApi(id) {
  return (0, _request.default)({
    url: "/admin/store/product/reply/info/".concat(id),
    method: 'GET'
  });
}
/**
 * 商品评论 删除
 * @param pram
 */
function replyDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/store/product/reply/delete/".concat(id),
    method: 'GET'
  });
}

/**
 * 商品评论 回复
 * @param pram
 */
function replyCommentApi(data) {
  return (0, _request.default)({
    url: "/admin/store/product/reply/comment",
    method: 'post',
    data: data
  });
}

/**
 * 商品评论 导出
 * @param pram
 */
function productExportApi() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var data = _objectSpread({}, params);
  if (data.showCateId) {
    data.showCateId = data.showCateId.join(',');
  }
  ;
  return (0, _request.default)({
    url: "/admin/export/excel/product",
    method: 'get',
    params: data
  });
}

/**
 * 商品复制 99Api
 * @param pram
 */
function importProductApi(params) {
  return (0, _request.default)({
    url: "/admin/store/product/importProduct",
    method: 'post',
    params: params
  });
}

/**
 * 商品复制 一号通
 * @param pram
 */
function copyProductApi(data) {
  return (0, _request.default)({
    url: "/admin/store/product/copy/product",
    method: 'post',
    data: data
  });
}

/**
 * 恢复
 * @param pram
 */
function restoreApi(id) {
  return (0, _request.default)({
    url: "/admin/store/product/restore/".concat(id),
    method: 'get'
  });
}

/**
 * 商品列表 导出
 * @param pram
 */
function productExcelApi(params) {
  var data = _objectSpread({}, params);
  var _ref5 = data.dateRange || [],
    _ref6 = _slicedToArray(_ref5, 2),
    startTime = _ref6[0],
    endTime = _ref6[1];
  if (startTime && endTime) {
    data['startTime'] = startTime;
    data['endTime'] = endTime;
  }
  ;
  if (data.showCateId) {
    data.showCateId = data.showCateId.join(',');
  }
  ;
  delete data.dateRange;
  return (0, _request.default)({
    url: "/admin/export/excel/product",
    method: 'get',
    params: data
  });
}

/**
 * 商品列表 获取复制商品配置
 * @param pram
 */
function copyConfigApi() {
  return (0, _request.default)({
    url: "/admin/store/product/copy/config",
    method: 'post'
  });
}

/**
 * 订单数据 导出
 * @param pram
 */
function orderExcelApi(params) {
  return (0, _request.default)({
    url: "/admin/export/excel/order",
    method: 'get',
    params: params
  });
}

// 三方商品-----------------------------------------------------
/**
 * 京东商品列表
 */
function thirdSkuLists() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var prams = _objectSpread({}, data);
  var _ref7 = prams.dataRenage || [],
    _ref8 = _slicedToArray(_ref7, 2),
    startTime = _ref8[0],
    endTime = _ref8[1];
  delete prams.dataRenage;
  prams = _objectSpread(_objectSpread({}, prams), {}, {
    startTime: startTime,
    endTime: endTime
  });
  return (0, _request.default)({
    url: "/admin/fusiling/jd/goods/list",
    method: 'post',
    data: prams
  });
}

/**
 * 京东商品-导出
 */
function exportJdGoods(data) {
  var inputNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var params = _objectSpread({}, data);
  delete params.page;
  delete params.limit;
  return (0, _request.default)({
    url: "/admin/fusiling/jd/goods/export",
    method: 'post',
    data: _objectSpread(_objectSpread({}, params), {}, {
      inputNum: inputNum
    })
  });
}

/**
 * 京东商品-修改排序
 */
function changeJdSort(params) {
  var goodsId = params.goodsId,
    sort = params.sort;
  return (0, _request.default)({
    url: "/admin/fusiling/jd/goods/sort/".concat(goodsId, "/").concat(sort),
    method: 'POST',
    params: params
  });
}

/**
 * 京东商品-修改默认售价
 */
function changeJdPrice(params) {
  var goodsId = params.goodsId,
    price = params.price;
  return (0, _request.default)({
    url: "/admin/fusiling/jd/goods/price/".concat(goodsId, "/").concat(price),
    method: 'POST',
    params: params
  });
}

/**
 * 分页获取三方商品列表
 */
function getThirdSkuList(data) {
  return (0, _request.default)({
    url: "/admin/customer/third/sku/list",
    method: 'post',
    data: data
  });
}

/**
 * 导出三方商品列表
 */
function exportThird(data) {
  var params = _objectSpread({}, data);
  delete params.page;
  delete params.limit;
  return (0, _request.default)({
    url: "/admin/customer/third/sku/export",
    method: 'post',
    data: params
  });
}

/**
 * 导入三方商品列表
 */
function importThirdGoods(data) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _request.default)({
    url: "/admin/customer/third/sku/import",
    method: 'post',
    data: data,
    params: params
  });
}

/**
 * 三方商品-改价
 */
function changeThirdPrice(data) {
  return (0, _request.default)({
    url: "/admin/customer/third/sku/price",
    method: 'put',
    data: data
  });
}

/**
 * 三方商品-修改状态
 */
function changeThirdState(data) {
  return (0, _request.default)({
    url: "/admin/customer/third/sku/status",
    method: 'put',
    data: data
  });
}

/**
 * 三方商品-同步商品信息
 */
function syncThirdSku() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var prams = _objectSpread({}, data);
  var _ref9 = prams.dataRenage || [],
    _ref0 = _slicedToArray(_ref9, 2),
    startTime = _ref0[0],
    endTime = _ref0[1];
  delete prams.dataRenage;
  delete prams.page;
  delete prams.limit;
  prams = _objectSpread(_objectSpread({}, prams), {}, {
    startTime: startTime,
    endTime: endTime
  });
  return (0, _request.default)({
    url: "/admin/fusiling/jd/goods/sync",
    method: 'get',
    data: prams
  });
}

/**
 * 展示商品
 */
function getCompanyLists(data) {
  var datas = _objectSpread({}, data);
  if (datas.showCateIds && datas.showCateIds.length) {
    var lists = datas.showCateIds.map(function (item) {
      var lastIdId = item[item.length - 1];
      return lastIdId || '';
    }) || [];
    datas['showCateIds'] = lists.filter(function (item) {
      return item;
    });
  }
  ;
  return (0, _request.default)({
    url: "/admin/show_product/list",
    method: 'post',
    data: datas
  });
}

/**
 * 全量同步
 */
function syncProduct(data) {
  return (0, _request.default)({
    url: "/admin/show_product/sync_data",
    method: 'post',
    data: data
  });
}

/**
 * 删除ShowProduct表数据后同步
 */
function deleteAndSyncProduct(data) {
  return (0, _request.default)({
    url: "/admin/show_product/sync_data",
    method: 'post',
    data: data
  });
}

/**
 * 保存修改
 */
function getProductSave(data) {
  return (0, _request.default)({
    url: "/admin/store/product/draft/save",
    method: 'post',
    data: data
  });
}

/**
 * 回显
 */
function getProductSaveDetail(params) {
  return (0, _request.default)({
    url: "/admin/store/product/draft/detail",
    method: 'get',
    params: params
  });
}

// 批量操作列表
function batchList(params) {
  return (0, _request.default)({
    url: "/admin/product/batch/list",
    method: 'get',
    params: params
  });
}

/**
 * 是否回显
 */
function getProductSaveHasDraft(params) {
  return (0, _request.default)({
    url: "/admin/store/product/draft/hasDraft",
    method: 'get',
    params: params
  });
}

/**
 * 是否删除回显
 */
function getProductRemoveByProduct(id) {
  return (0, _request.default)({
    url: "/admin/store/product/draft/removeByProduct?productId=".concat(id),
    method: 'post'
  });
}

// 获取上传文件nama
function batchFileName(fileName) {
  return (0, _request.default)({
    url: "/admin/product/batch/check/file?fileName=".concat(fileName),
    method: 'post'
  });
}

// 上传文件
function batchTask(formData) {
  return (0, _request.default)({
    url: "/admin/product/batch/add/task",
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}

// 导出模板
function batchTemplate(params) {
  return (0, _request.default)({
    url: "/admin/product/batch/export/template",
    method: 'get',
    params: params
  });
}

// 查看日志
function batchLogs(params) {
  return (0, _request.default)({
    url: "/admin/product/batch/detail",
    method: 'get',
    params: params
  });
}

// 暂停/开始执行
function batchTurnTask(batchId) {
  return (0, _request.default)({
    url: "/admin/product/batch/turn/task?batchId=".concat(batchId),
    method: 'post'
  });
}

// 暂停/开始执行
function batchTurnTaskList(params) {
  return (0, _request.default)({
    url: "/admin/product/batch/detail/list",
    method: 'get',
    params: params
  });
}

// SKU图片上传
function batchImage(data) {
  return (0, _request.default)({
    url: "/admin/product/batch/sku/image",
    method: 'POST',
    data: data
  });
}

// 商品图片上传SPU
function batchSpuImage(data) {
  return (0, _request.default)({
    url: "/admin/product/batch/product/image",
    method: 'POST',
    data: data
  });
}

// 上架
function batchPutOnShell(id) {
  return (0, _request.default)({
    url: "/admin/store/product/putOnShell/".concat(id),
    method: 'get'
  });
}

// 下架
function batchOffShellt(id) {
  return (0, _request.default)({
    url: "/admin/store/product/offShell/".concat(id),
    method: 'get'
  });
}

//SKU下架
function batchUpdateStatus(params) {
  return (0, _request.default)({
    url: "/admin/store/sku/updateStatus",
    method: 'get',
    params: params
  });
}

//SKU采销状态
function batchUpdateCpStatus(params) {
  return (0, _request.default)({
    url: "/admin/store/sku/updateCpStatus",
    method: 'get',
    params: params
  });
}

//价格变动查询
function priceAdjustmentLogApi(params) {
  return (0, _request.default)({
    url: "/admin/store/product/price/log",
    method: 'get',
    params: params
  });
}

//价格变动查询-供应商
function priceAdjustmentLogApi2(params) {
  return (0, _request.default)({
    url: "/admin/supplier/product/price/log",
    method: 'get',
    params: params
  });
}

//提交审核
function auditEditApi(data) {
  return (0, _request.default)({
    url: "/admin/store/product/verify",
    method: 'POST',
    data: data
  });
}

// 一卡通库存管理 ---------------------------------------------
/**
 * 一卡通库存列表
 */
function cardSkuLists() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: "/admin/onecard/sku/manage/list",
    method: 'GET',
    params: data
  });
}

/**
 * 一卡通库存 - 新增
 */
function cardSkuAdd(data) {
  return (0, _request.default)({
    url: "/admin/onecard/sku/manage",
    method: 'POST',
    data: data
  });
}

/**
 * 一卡通库存 - 删除
 */
function cardSkuDelete(id) {
  return (0, _request.default)({
    url: "/admin/card/sku/delete/".concat(id),
    method: 'DELETE'
  });
}

/**
 * 一卡通库存 - 平台下拉
 */
function cardSkuPlatformOptions() {
  return (0, _request.default)({
    url: "/admin/card/sku/platform/options",
    method: 'GET'
  });
}

/**
 * 一卡通库存 - 产品名称下拉
 */
function cardSkuProductOptions() {
  return (0, _request.default)({
    url: "/admin/onecard/sku/manage/options",
    method: 'GET'
  });
}

/**
 * 一卡通库存 - 卡类型下拉
 */
function oneCardTypeOptions() {
  return (0, _request.default)({
    url: "/admin/onecard/sku/manage/card-type/options",
    method: 'GET'
  });
}

/**
 * 一卡通库存 - 生成批次卡密商品下拉
 */
function cardBatchSkuOptions() {
  return (0, _request.default)({
    url: "/admin/onecard/batch/sku/options",
    method: 'GET'
  });
}

/**
 * 一卡通库存 - 生成批次卡密
 */
function cardBatchGenerate(data) {
  return (0, _request.default)({
    url: "/admin/onecard/batch/generate",
    method: 'POST',
    data: data
  });
}

/**
 * 一卡通库存 - 批次操作日志
 */
function cardBatchLogPage() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: "/admin/onecard/batch/logPage",
    method: 'GET',
    params: params
  });
}

/**
 * 一卡通库存 - 导出批次操作日志
 */
function cardBatchLogExport() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: "/admin/onecard/batch/exportLog",
    method: 'GET',
    params: params
  });
}

/**
 * 一卡通库存详情 - 实例卡分页
 */
function cardInstanceCardPage() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: "/admin/onecard/instanceCard/page",
    method: 'GET',
    params: params
  });
}

/**
 * 一卡通库存详情 - 导出实例卡
 */
function cardInstanceCardExport() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: "/admin/onecard/instanceCard/export",
    method: 'GET',
    params: params
  });
}

/**
 * 美景一卡通 - 导入卡号卡密
 */
function oneCardMeijingImport(data, skuId) {
  return (0, _request.default)({
    url: "/admin/onecard/instanceCard/import",
    method: 'POST',
    params: {
      skuId: skuId
    },
    data: data
  });
}

/**
 * 美景一卡通 - 下载导入模板
 */
function downloadMeijingOneCardImportTemplate() {
  return (0, _request.default)({
    url: '/admin/export/excel/template',
    method: 'GET',
    params: {
      fileName: 'mj_one_card_import_template.xlsx'
    }
  });
}

/**
 * 一卡通库存详情 - 实例卡使用详情
 */
function cardInstanceUseDetail() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: "/admin/onecard/instanceCard/useDetail",
    method: 'GET',
    params: params
  });
}

/**
 * 一卡通库存详情 - 权益使用记录
 */
function cardRightUseRecord() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: "/admin/onecard/instanceCard/rightUseRecord",
    method: 'GET',
    params: params
  });
}

/**
 * 一卡通库存详情 - 小程序下拉
 */
function cardCustomerAppOptions() {
  return (0, _request.default)({
    url: "/admin/customers/customer/app",
    method: 'GET'
  });
}

/**
 * 一卡通权益配置 - 分页列表
 */
function oneCardRightConfigPage() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: "/admin/onecard/rightConfig/page",
    method: 'GET',
    params: params
  });
}

/**
 * 一卡通权益配置 - 配置详情
 */
function oneCardRightConfigDetail() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: "/admin/onecard/rightConfig/detail",
    method: 'GET',
    params: params
  });
}

/**
 * 一卡通权益配置 - 可关联商品
 */
function oneCardRightProductOptions() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: "/admin/onecard/rightConfig/productOptions",
    method: 'GET',
    params: params
  });
}

/**
 * 一卡通权益配置 - 保存
 */
function oneCardRightConfigSave(data) {
  return (0, _request.default)({
    url: "/admin/onecard/rightConfig/save",
    method: 'POST',
    data: data
  });
}